import { Prisma } from "@prisma/client";

import { prisma } from "@/lib/prisma";

export async function getPublicTalksByApplicationId(applicationId: string) {
  return await prisma.applicantPublicTalk.findMany({
    where: {
      applicant: {
        Application: {
          every: {
            id: applicationId,
          },
        },
      },
    },
    orderBy: { sortOrder: Prisma.SortOrder.asc },
  });
}
